var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"m-sticky-item"},[_c('div',{staticClass:"m-sticky-item__container",style:(_vm.getWrapStyle)},[_c('div',{ref:"header",staticClass:"m-sticky-item__header",class:{ 'm-sticky-item__is-fixed': _vm.isFixed },style:(_vm.getStyle)},[_vm._t("title")],2)]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }